import React, { FC, ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import styled from "@emotion/styled";
import { Reminder } from "@models/reminder";
import { ActivityType } from "@models/activity-type";
import { CronUtil } from "@utils/cron.util";
import InsertPhotoOutlinedIcon from "@mui/icons-material/InsertPhotoOutlined";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import MedicationOutlinedIcon from "@mui/icons-material/MedicationOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import StyledChip from "@components/StyledChip";
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import { RootState } from '@store/store';
import { Mode } from '@store/homeSlice';
import ReactTimeAgo from 'react-time-ago';

const Container = styled.div`
  border-radius: 4px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.08);
  border-style: solid;
  padding: 10px 20px;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const icons: Record<ActivityType, ReactNode> = {
  [ActivityType.Conversation]: <SmsOutlinedIcon color="primary" />,
  [ActivityType.GallerySession]: <InsertPhotoOutlinedIcon color="primary" />,
  [ActivityType.Medication]: <MedicationOutlinedIcon color="primary" />,
  [ActivityType.Other]: <CalendarMonthOutlinedIcon color="primary" />,
};

const ReminderItem: FC<{
  reminder: Reminder;
  nextDate: Date;
}> = ({ reminder, nextDate }) => {
  const mode = useSelector((state: RootState) => state.home.mode);
  return (
    <Container>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        gap="8px"
      >
        <Typography
          color="textSecondary"
          fontSize="20px"
          fontWeight="500"
          lineHeight="30px"
          marginBottom="6px"
          sx={{ textDecoration: "none" }}
          component={Link}
          to={`schedule/${reminder.id}`}
        >
          {reminder.title}
        </Typography>

        {icons[reminder.activityType]}
      </Box>

      <Typography
        fontSize="14px"
        lineHeight="22px"
        fontWeight="400"
        color="#171A1FFF"
      >
        {reminder.description}
      </Typography>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginTop="17px"
        gap="8px"
      >
        {mode === Mode.Caregiver ? (
          <StyledChip
            label={CronUtil.toHumanReadable(reminder.schedule)}
            variant="filled"
            color="primary"
          />
        ) : (<span></span>)}

        <Typography
          fontSize="14px"
          lineHeight="22px"
          fontWeight="400"
          color="#171A1FFF"
        >
          <ReactTimeAgo date={nextDate}/>
        </Typography>
      </Box>
    </Container>
  );
};

export default ReminderItem;
